module.exports = __webpack_public_path__ + "assets/img/network-new.6cbe9213.svg";